import React from "react";

function displayName(u) {
  if (!u) return "";
  const parts = [u.salutation, u.first_name, u.last_name].filter((p) => p != null && String(p).trim() !== "");
  const line = parts.map((p) => String(p).trim()).join(" ");
  return line || u.email || u.username || "";
}

const labelClass = "text-soft text-uppercase mb-1";
const labelStyle = { fontSize: "0.65rem", letterSpacing: "0.04em" };

const MedicalPartnerListPrimaryUserCell = ({ item, onAssignPrimaryUser }) => {
  const u = item?.userId;

  return (
    <button
      type="button"
      className="btn btn-link text-start p-0 text-small text-decoration-none w-100"
      onClick={(e) => {
        e.stopPropagation();
        onAssignPrimaryUser(item);
      }}
    >
      {u ? (
        <div className="d-flex flex-column align-items-stretch w-100">
          <div>
            <div className={labelClass} style={labelStyle}>
              Name
            </div>
            <div className="text-dark text-truncate" title={displayName(u)}>
              {displayName(u) || "—"}
            </div>
          </div>
          <div className="mt-2 pt-1 border-top border-light w-100">
            <div className={labelClass} style={labelStyle}>
              Email
            </div>
            <div className="text-soft text-truncate small" title={u.email || ""}>
              {u.email || "—"}
            </div>
          </div>
        </div>
      ) : (
        <span className="text-warning">Assign primary user…</span>
      )}
    </button>
  );
};

export default MedicalPartnerListPrimaryUserCell;
